<template>
  <div id="app">
    <div class="wrapper">
      <component v-bind:is="layout"></component>
    </div>
  </div>
</template>

<script>
import store from './vuex/store.js'
import { mapGetters } from 'vuex'
import DefaultLayout from './components/layout/DefaultLayout.vue'
import Master from './components/layout/Master.vue'
import MasterOrange from './components/layout/MasterOrange.vue'

import moment from 'moment/moment.js'

export default {
  name: 'app',
  data () {
    return {
      layout: '',
      timeout: null,
      interval: null
    }
  },
  watch: {
    loggedIn: function (newVal, oldVal) {
      this.evaluateLogIn()
    }
  },
  created () {
  },
  mounted () {
    this.evaluateLogIn()
  },
  components: {
    'defaultLayout': DefaultLayout,
    'master': Master,
    'masterOrange': MasterOrange
  },
  methods: {
    evaluateLogIn () {
      const linkForFavicon = document.querySelector(`head > link[rel='icon']`)

      // ATI - WCR
      let isDefault = false
      if (this.$router.currentRoute.name === 'Login' || this.$router.currentRoute.name === 'Tracking' || this.$router.currentRoute.name === 'TrackingOrder') {
        isDefault = true
      }
      if (this.loggedIn && !isDefault) {
        this.interval = setInterval(() => { this.checkSessionTimeOut() }, 1000)
        document.addEventListener('mousemove', this.refreshIdleTimeOut)
        this.refreshIdleTimeOut()
        this.layout = 'masterOrange'
        linkForFavicon.setAttribute('href', '/static/img/icons/ic_dinet_logo.png')
      } else {
        document.removeEventListener('mousemove', this.refreshIdleTimeOut)
        this.clearTimers()
        this.layout = 'defaultLayout'
        if (this.$router.currentRoute.name === 'Tracking' || this.$router.currentRoute.name === 'TrackingOrder') {
          linkForFavicon.setAttribute('href', '/static/img/logo.png')
        } else {
          linkForFavicon.setAttribute('href', '/static/img/icons/ic_dinet_logo.png')
        }
      }
    },
    refreshIdleTimeOut () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => { this.$router.push({ name: 'Logout' }) }, (this.userTimeout.timeInactivitySession * 1000))
    },
    checkSessionTimeOut () {
      let now = moment()
      let login = moment(this.userTimeout.timeLogin)
      let diff = moment.duration(now.diff(login)).asSeconds()

      if (diff >= this.userTimeout.timeEndSession) {
        // this.$router.push({ name: 'Logout' })
      }
    },
    clearTimers () {
      clearInterval(this.interval)
      clearTimeout(this.timeout)
    }
  },
  store,
  computed: {
    ...mapGetters([
      'loggedIn',
      'userTimeout'
    ])
  }
}
</script>

<style>

.vuetable-empty-result{
  padding: 10px !important;
}

@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');

.filterContainer {
  background: #F8F8F8;
  border-radius: 5px;
  padding: 5px;
}

.btnAction {
  width: 100px;
	font-size: 16px;
  letter-spacing: -0.38px;	
  line-height: 20px;
}

.box{
  box-shadow: none !important;
}

.btn-success, .btn-success:hover, .btn-success:active, .btn-success:visited {
  background-color: #009d00 !important;
}


.btn-success:hover {
  background-color: #027302 !important;
}

.box-success {
  border-radius: 0px;
  border: 1px solid #E3E3E3 !important;
  background-color: #FFFFFF !important;
}

.panel-heading {
  background-color: #009d00 !important;
}

.skin-green .main-header .navbar {
	height: 60px;
	/* border: 1px solid #E2E2E2; */
  border: 0px !important;
  /* background-color: #FFFFFF !important; */
  background-color: transparent !important;
}
/* 
.router-link-exact-active a {
  border-color: #009d00 !important;
  background-color: #183764 !important;
}
 */

/* Inicio ATI - WCR */
.router-link-exact-active a {
  border-color: #009d00 !important;
  background-color: #ffffff !important;
}

.router-link-exact-active a img {
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.router-link-exact-active a div img {
  filter: brightness(0) saturate(100%) invert(37%) sepia(98%) saturate(2005%) hue-rotate(92deg) brightness(91%) contrast(109%);
}

.router-link-exact-active a div {
  background: rgba(0, 157, 0, 0.1);
  border-radius: 8px;  
  height: 36px;
}

.router-link-exact-active a div div {
  background: transparent;
  color:#009d00;
  border-radius: 8px;  
  height: 36px;
}

/* Fin ATI - WCR */

.user-header {
  background-color: #009d00!important;
}

.vuetable thead tr th {
  	color: rgba(54,74,93,0.5);
    border: none;
    text-transform: uppercase;
    font-family: 'Avenir', 'Arial';
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.34px;
    line-height: 19px;
}

.sidebar{
  padding-top: 29px;
}

.form-control{
  	height: 48px !important;		
    border: 1px solid #D8D8D8;	
    background-color: #FFFFFF;
}

.btn-item-group{
  background-color: none !important;

}

.btn-group>.btn{
  position: relative;
  background: none !important;
  color: #364A5D;
  font-size: 14px;
  font-weight: 550;
  border: 1px solid rgba(58,68,96,0.6);
  border-radius: 4px;
  height: 48px !important;
  width: 20% !important;
}

.btn-group>.btn:hover{
    border-radius: 4px 4px 4px 4px;
  	background-color: #3A4460 !important;
    color: white;
}

.btn-group>.btn-success{
   	background-color: #3A4460 !important;
    color: white;
}

@font-face {
  font-family: 'Avenir';
  src: local('Awesome Font'), 
  url('/static/Fonts/Avenir/AvenirLTStd-Book.otf') format('truetype');
}

.box-header{
  height: 60px !important;
  text-align:left;
  padding-left: 0px;
}

.box-title-sub{
  font-family:'Avenir', 'Arial' !important;
  padding-top: 5px;
  text-transform: uppercase;
  color:#4E6982;
  padding-left: 15px;
  font-size: 15px !important;
}

.icon-space{
  padding-right:8px
}

.font-color-table{
  color:#364A5D;
}

.title{
   font-family:'Avenir', 'Arial' !important;
   font-size: 25px !important;	
   padding-left: 0px !important;
   color:#4E6982;
}

.box-title{
  font-family:'Avenir', 'Arial' !important;
  color:#4E6982;
  font-weight: bold !important;
}

.btn-table{
  background:none;
  color: #444444;
  border: none;
  font-size: 16px;
  letter-spacing: 
  -0.31px;	
  line-height: 20px;
}

.btn-table:hover{
  background:none;
  border: none;
  color: black;
  font-weight: 900;
}

.btn-table .btn-primary{
  font-weight: 900;
}

.btn-table:focus{
  font-weight: 900;
}

.btn-primary{
  font-weight: bold;
  font-size: 16px;
}


.form-control.client{
  width: 300px!important;
}

.multiselect__select{
  top: 7px !important;
}

.multiselect__option--highlight{
  background:#1E87DA !important;
}

.multiselect__single{
  top:3px !important;
}

.multiselect__tags{
  border:1px solid #D8D8D8 !important;
  background-color: #FFFFFF !important;
  border-radius: 0px !important;
  min-height: 48px !important;
  height: 48px !important;
  border-radius: 0px !important;
}

.btn-success{
  height: 48px !important;
}

.btn-default{
  height: 48px !important;
}

/* Estilo Select */
select.minimal {
  background-image: url('/static/img/drop3.svg');
  background-position:
    calc(100% - 20px) calc(1em + 10px),
    calc(100% - 15px) calc(1em + 10px),
    calc(100% - 2.5em) 0.5em;
  background-size:11px;
  background-repeat: no-repeat;
  transition: .1s;
}

select.minimal:focus {
  background-image:
    linear-gradient(45deg, gray 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, gray 50%);
 
  background-position:
    calc(100% - 15px) calc(1em + 10px),
    calc(100% - 20px) calc(1em + 10px),
    calc(100% - 2.5em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
  outline: 0;
} 

select {

  /* styling */
  background-color: white;;
  display: inline-block;
  font: inherit;
  /* reset */
  
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

.progressContainer {
  width: 100%;
  position: relative;
}

.progressBar,
.progressInfo {
  width: 100%;
/*   position: absolute; */
  top: 0;
  left: 0;
}

.ati-header
{
  z-index: 5;
  position: fixed;
  padding-top: 25px;  
}

.vld-parent
{
  padding-top: 70px;
}

@media screen and (max-width: 450px) {

/* .btn-group{
  
  }  */

  .btn-group>.btn{
    font-size: 13px;
  } 

  .segundo-btn{
  position: relative;
  left: -4px;
}
}


@media screen and (max-width: 390px) {

/*   .btn-group{
    } */

    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -7px;
    }

}

@media screen and (max-width: 1150px) {
/* 
  .btn-group{
    }
 */
    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -1px;
    }

}


@media screen and (max-width: 1120px) {

  /* .btn-group{
    }
 */
    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -5px;
    }

}

@media screen and (max-width: 390px) {

/*   .btn-group{
    } */

    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -7px;
    }

}

@media screen and (max-width: 350px) {
/* 
.btn-group{
  }  */
  .btn-group>.btn{
    font-size: 11px;
  } 

  .segundo-btn{
  position: relative;
  left: -8px;
  }

  .title{
   font-size: 24px !important;	
   padding-left: 0px !important;
   color:#4E6982;
  }
}

@media screen and (max-width: 360px) {

/*   .btn-group{
    } */

    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -7px;
    }

}

@media screen and (max-width: 340px) {

/*   .btn-group{
    } */

    .btn-group>.btn{
      font-size: 13px;
    }

    .segundo-btn{
    position: relative;
    left: -9px;
    }

}


@media screen and (max-width: 330px) {
  .title{
   font-size: 18px !important;	
   padding-left: 0px !important;
   color:#4E6982;
  }
}

@media screen and (max-width: 430px) {
  .title{
   font-size: 18px !important;	
   padding-left: 0px !important;
   color:#4E6982;
  }
}

@media screen and (max-width: 320px) {
  .title{
   font-size: 18px !important;	
   padding-left: 0px !important;
   color:#4E6982;
  }
}
@media screen and (max-width: 610px) {
  .title{
   font-size: 18px !important;	
   padding-left: 0px !important;
   color:#4E6982;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?b64bf252